<div class="dialog-confirmation-mobile" fxLayout="column">
    @for (option of data.options; track option.value) {
        <button
            class="option-button"
            (click)="handleOptionClick(option)"
            [class.alert]="option.alert"
        >
            {{ option.label }}
        </button>
    }
</div>
